document.addEventListener('DOMContentLoaded', function () {


//  Custom review slider
 function initReviewSlide(){
    const splideElement = document.querySelector('.cust_reviewSlider');
    if (!splideElement) return;
    const nav = document.querySelector('.review_nav');
    const prevBtn = document.querySelector('.review_prev');
    const nextBtn = document.querySelector('.review_next');
    const items = splideElement?.querySelectorAll('.review_item').length;

    // Splide setup
    var splide = new Splide('.cust_reviewSlider', {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '1.4rem',
        pagination: false,
        arrows: false,
        breakpoints: {
            990: { perPage: 2 },
            640: { perPage: 1 }
        }
    });

    splide.mount();

    // Custom Buttons
    prevBtn.addEventListener('click', () => splide.go('<'));
    nextBtn.addEventListener('click', () => splide.go('>'));

    // ---- Hide/Show Nav Based on Conditions + Add disabled class ---- //
    function updateNavVisibility() {
    const width = window.innerWidth;

    let hideNav = false;

    if (width >= 990 && items < 4) hideNav = true;
    else if (width < 990 && width >= 640 && items < 3) hideNav = true;
    else if (width < 640 && items < 2) hideNav = true;

    if (hideNav) {
        nav.style.display = 'none';
        prevBtn.classList.add('disabled');
        nextBtn.classList.add('disabled');
    } else {
        nav.style.display = 'flex';
        prevBtn.classList.remove('disabled');
        nextBtn.classList.remove('disabled');
    }

    updateArrowState(); // handle disabled at edges
    }

    // ---- Disable arrows when at start/end ---- //
    function updateArrowState() {
    if (nav.style.display === 'none') return; // no arrows visible

    if (splide.index === 0) {
        prevBtn.classList.add('disabled');
    } else {
        prevBtn.classList.remove('disabled');
    }

    if (splide.index === splide.length - splide.options.perPage) {
        nextBtn.classList.add('disabled');
    } else {
        nextBtn.classList.remove('disabled');
    }
    }

    updateNavVisibility();
    window.addEventListener('resize', updateNavVisibility);

    // Update arrow state on slide movement
    splide.on('move', updateArrowState);
    splide.on('mounted', updateArrowState);

  }

  initReviewSlide();


  //customise function
  const reviewSec = document.querySelector(".cust_reviewWrap");
  let isDesign = reviewSec?.dataset.isDesign;

  if ( isDesign == 'true') document.addEventListener('shopify:section:load', initReviewSlide);
    
    
  

//  Custom review slider


//------------------------ Index Video Section ----------------------
const videoSections = document.querySelectorAll('.video-sec');
if (!videoSections.length) return;

videoSections.forEach(function (section) {

    // Handle each click button inside this section only
    section.querySelectorAll('.vdo-btn-click').forEach(function (button) {

    button.addEventListener('click', function () {
        const thumbWrap = this.closest('.thumb-btn-wrap');
        const video = section.querySelector('video');

        if (!video || !thumbWrap) return;

        video.play().catch(err => console.warn('Playback blocked:', err));

        thumbWrap.style.display = 'none';

        video.addEventListener('ended', function () {
        thumbWrap.style.display = 'flex';
        });
    });

    });

});


    //----------------- Index FAQ Section -------------------------
     const accordion = document.querySelector('.accordion');
    if (!accordion) return;

    const openFirst = accordion.dataset.openFirst === 'true';
    const headers = accordion.querySelectorAll('.accordion-header');

    headers.forEach((header, index) => {
      const content = header.nextElementSibling;

      // Open the first item if setting is true
      if (openFirst && index === 0) {
        header.classList.add('active');
        content.classList.add('show');
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      header.addEventListener('click', () => {
        const content = header.nextElementSibling;

        // Close others
        accordion.querySelectorAll('.accordion-content').forEach((other) => {
          if (other !== content) {
            other.style.maxHeight = null;
            other.classList.remove('show');
            other.previousElementSibling.classList.remove('active');
          }
        });

        // Toggle clicked
        if (content.classList.contains('show')) {
          content.style.maxHeight = null;
          content.classList.remove('show');
          header.classList.remove('active');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.add('show');
          header.classList.add('active');
        }
      });
    });

    // Recalculate height on resize
    window.addEventListener('resize', () => {
      accordion.querySelectorAll('.accordion-content.show').forEach((content) => {
        content.style.maxHeight = content.scrollHeight + 'px';
      });
    });

});
